import React, {Component} from 'react';

import { Form, Row, Button, message , Modal, Select} from 'antd';

import components from './../components';

import service from './../services';

class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            imageUrl: service.account.getKaphcha(),
            systemName: '',
            schoolLogo: '',
            copyright: '',
            loginRoleSelectOpen: false,
            defaultValue : 2
        }
    }

    componentDidMount() {
        service.account.website().then(data => {
            sessionStorage.setItem('website', JSON.stringify(data));
            document.title = data.systemName;
            this.setState(Object.assign({}, this.state, data));
        });
    }



    onChange() {
        const imageUrl = service.account.getKaphcha();
        this.setState({
            imageUrl
        });
    }

    onSubmit(event) {
        event.preventDefault();
        this.props.form.validateFields((error, values) => {
            if(!error) {
                this.setState({
                    loading: true
                });
                service.account.login(values).then(payload => {
                    this.setState({
                        loading: false
                    });
                    if(payload.code != undefined && payload.code == 412){
                        Modal.warn({
                            title : '提示',
                            content : '您的密码为初始化密码，请您修改密码后再进行登录',
                            onOk : ()=> {
                                window.location.hash = '/employeePwd';
                                window.location.reload();
                            },
                            okText : '前往',
                            cancelText : '取消'
                        })
                        return 
                    }
                    if(payload.code != undefined && payload.code == 60003){
                        Modal.confirm({
                            title : '提示',
                            content : '您的账号已经登录，请问是否继续登录？',
                            onOk : ()=> {
                                values.relogin = true
                                service.account.login(values).then(payload =>{
                                    window.location.hash = '/';
                                    if(payload) {
                                      this.props.updateAccount(payload);
                                    }
                                    this.onChange();
                                })
                            },
                            okText : '前往',
                            cancelText : '取消'
                        })
                        return 
                    }
                    window.location.hash = '/';
                    if(payload) {
                      this.props.updateAccount(payload);
                    }
                    this.onChange();
                }).catch(error => {
                    message.error(error.message);
                });
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <div className="root-login-wrapper">
                <h2 className="root-title"><i><img src={this.state.schoolLogo} /></i>{this.state.systemName}</h2>
                <div className="root-login-container">
                    <div className="root-login">
                        <h2>用户登录</h2>
                        <div className="root-login-modal">
                            
                            <Form className="root-login-form" layout="inline" onSubmit={this.onSubmit.bind(this)}>
                                <Row>
                                    <components.Input name="username" label="用户名" getFieldDecorator={getFieldDecorator} style={{width: 200}} />
                                </Row>
                                <Row>
                                    <components.Input name="password" label="密 码" type="password" getFieldDecorator={getFieldDecorator} style={{width: 200}} />
                                </Row>
                                {
                                    this.state.loginRoleSelectOpen ? 
                                    <Row>
                                        <Form.Item label="角 色">
                                            {   
                                                getFieldDecorator('roleId',{
                                                    initialValue: this.state.defaultValue,
                                                    rules: [{
                                                        required: true,
                                                        message: '请选择角色',
                                                    }],
                                                })(
                                                    <Select
                                                        placeholder="请选择角色..."
                                                        allowClear
                                                        style={{width: 200}}
                                                        // value={this.state.roleId}
                                                        onChange={(value)=>{
                                                            if(value){
                                                                this.setState({
                                                                    roleId : value
                                                                })
                                                            }
                                                        }}
                                                    >
                                                        <Select.Option value={1}>学生</Select.Option>
                                                        <Select.Option value={2}>教师/管理员</Select.Option>
                                                        <Select.Option value={3}>评审专家</Select.Option>
                                                    </Select>    
                                                )
                                            }
                                        </Form.Item>
                                    </Row>
                                    :
                                    ''
                                }
                                <Row>
                                    <components.Input name="kaptcha" label="验证码" getFieldDecorator={getFieldDecorator} style={{width: 100}} />
                                    <span className="image-kaptcha">
                                        <img src={this.state.imageUrl} alt="验证码"/>
                                    </span>
                                    <span className="change-image" onClick={this.onChange.bind(this)}>换一张！</span>
                                </Row>
                                <Row>
                                {/* <Row>
                                    <span style={{marginLeft : 45}}>
                                        <img style={{width : 25 , height :25 , verticalAlign:'bottom'}} src="dingding.svg"></img>
                                        <a style={{verticalAlign : 'middle'}} href="#/dingding" target="_blank">前往钉钉扫码登录</a>
                                    </span>
                                </Row> */}
                                <Button loading={this.state.loading} size="large" className="login-form-button" htmlType="submit" type="primary">确认</Button>
                                {/* <Button
                                    className="login-form-button"
                                    style={{marginTop: 5}}
                                    size="large" 
                                    onClick={() => {
                                        window.location.hash = "/user/register";
                                        window.location.reload();
                                    }}
                                >注册</Button> */}
                                </Row>
                            </Form>
                        </div>
                    </div>
                </div>
                <p>Copyright&copy; {this.state.copyright.split(';')[1]}</p>
            </div>
        );
    }
}

export default Form.create()(Login);